module.exports = __webpack_public_path__ + "media/icons/r-dark-402e2f57.svg";